import { appLog } from '~src/utils/log';
import { apiCweb } from './api-cweb';

export interface Tag {
  id: number;
  projectId: string;
  state: number;
  title: string;
  description: string;
}

export interface LoadArchiveSettingsParams {
  projectId: string;
}

export interface LoadArchiveSettingsReturnType {
  created_at: number;
  created_by: number;
  is_archive_on: boolean;
  is_email_notification_on: boolean;
  is_module_archive_on: boolean;
  is_sector_archive_on: boolean;
  is_tags_on: boolean;
  is_tendering_on: boolean;
  primary_svf_render_id?: number | null;
  project_id: number;
  state: number;
  updated_at: number;
  updated_by: number;
}

export interface LoadArchiveSettingsResponse {
  resTags?: LoadTagsReturnType;
  resArchiveSettings: LoadArchiveSettingsReturnType;
}

export type LoadTagsReturnType = Tag[];

export interface UpdateArchiveSettingsType {
  projectId: number;
  is_tags_on: boolean;
}

export const updateArchiveSettings = async ({
  projectId,
  is_tags_on,
}: UpdateArchiveSettingsType): Promise<void> => {
  appLog('updateArchiveSettings ->', { projectId });

  const res = await apiCweb.put<void>(
    `/projects/${projectId}/archive_settings?action=set_tag_${
      is_tags_on ? 'on' : 'off'
    }`,
    {}
  );
  return res.data;
};

export const loadArchiveSettings = async (
  key: string,
  { projectId }: LoadArchiveSettingsParams
): Promise<LoadArchiveSettingsResponse> => {
  appLog('loadArchiveSettings ->', {
    projectId,
  });

  const resArchiveSettings = await apiCweb.get<LoadArchiveSettingsReturnType>(
    `/projects/${projectId}/archive_settings`
  );

  if (resArchiveSettings.data.is_tags_on) {
    const resTags = await apiCweb.get<LoadTagsReturnType>(
      `/projects/${projectId}/tags?skip=0&show_deleted=true`
    );
    return {
      resTags: resTags.data,
      resArchiveSettings: resArchiveSettings.data,
    };
  }

  return { resArchiveSettings: resArchiveSettings.data };
};
